import { type TrialAssociation } from '@modules/trials/types/TrialAssociation'
import { getTimelineValues } from './getTimelineValues'
import { MobileTimeline } from './MobileTimeline'
import { OneRowTimeline } from './OneRowTimeline'
import { TimelineCardCaption } from './TimelineCardCaption'

export const TimelineCard = ({ trial }: { trial: TrialAssociation }) => {
  const { reporting, screening, treatment } = getTimelineValues(trial)
  return (
    <div
      className={`rounded-xl border border-neutral200  p-4 lg:rounded-2xl lg:p-6`}
    >
      <div className='hidden md:block'>
        <OneRowTimeline
          iconColor='text-blue500'
          nctId={trial.nctId}
          reporting={reporting}
          screening={screening}
          treatment={treatment}
        />
      </div>
      <div className='block md:hidden'>
        <MobileTimeline
          nctId={trial.nctId}
          reporting={reporting}
          screening={screening}
          treatment={treatment}
        />
      </div>
      <TimelineCardCaption
        nctId={trial.nctId}
        reporting={reporting}
        screening={screening}
        treatment={treatment}
      />
    </div>
  )
}
